import React from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import { useDirtyWarningContext, DirtyWarningInputProps } from '../DirtyWarning';

export interface TextBoxProps extends DirtyWarningInputProps {    
    name: string;
    onChange?: (e: React.FormEvent<FormControl>) => void;
    onClick?: () => void;
    onBlur?: () => void;
    onEnter?: () => void;
    
    label?: string;
    key?: string;    
    placeholder?: string;
    value?: any;
    readOnly?: boolean;
    disabled?: boolean;
    pattern?: string;
    type?: string;
    maxLength? : number;

    autoFocus?: boolean;
    multiline?: boolean;
    rows?: number;
    cols?: number;
    resize?: "none" | "both" | "horizontal" | "vertical" | "initial" | "inherit";

    validationState?: () => 'success' | 'warning' | 'error' | null;
}

export const TextBox: React.FC<TextBoxProps> = (props) => {
    const { multiline, validationState, onChange, disableDirtyTracking = false, ...textBoxProps} = props;
    const validationStateResult = validationState ? validationState() : null;
    const context = useDirtyWarningContext();
    let resize = (props.resize) ? props.resize : "vertical";

    const handleChange = (e: any) => {        
        if (onChange) {
            onChange(e);
        }

        if (disableDirtyTracking) return;
        
        context.setDirty(true);
    }

    const handleKeyDown = (event : React.KeyboardEvent<FormControl>) => {
        if (event.key === 'Enter' && props.onEnter) {
            props.onEnter();
        }
    }
    
    let textBox = (
        <FormControl 
            componentClass={multiline ? 'textarea' : 'input'} 
            autoFocus={props.autoFocus}
            onChange={handleChange} 
            onBlur={props.onBlur} 
            onKeyDown={handleKeyDown}
            {...textBoxProps} 
            style={{resize}}
        />
    );

    if (!props.label) return textBox;

    return (
        <FormGroup controlId={props.key} validationState={validationStateResult}>
            <ControlLabel>{props.label}</ControlLabel>
            {textBox}
        </FormGroup>
    )
}

(TextBox as any).displayName = 'TextBox';